import fetch from "@lib/fetch";
import { API } from "../../config";

export const signUp = (data) => {
  let user = {
    first_name: data.firstName,
    last_name: data.lastName,
    email: data.email,
    password: data.password,
    phone:data.phone,
    source: data.source || 'webApp'
  };

  return fetch(`${API}/v1/signup`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(user)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
}


export const signIn = (user) => {
  return fetch(`${API}/v1/signin`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(user)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};


export const signInCommunity = (user) => {
  return fetch(`${API}/v1/community/signin`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      email:user.email,
      password:user.password,
      sso:user.sso,
      sig:user.sig
    })
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};


export const authenticate = (data , next) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('jwt', JSON.stringify(data));
    next();
  }
};

export const signOut = next => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('jwt');
    next();
    return fetch(`${API}/v1/signout`, {
      method: "GET"
    })
      .then(res => {
        console.log('signout', res);
      })
      .catch(err => {
        console.log(err);
      })
  }
};

export const isAuthenticated = () => {
  if (typeof window == 'undefined') {
    return false
  }
  if (localStorage.getItem('jwt')) {
    return JSON.parse(localStorage.getItem('jwt'));
  } else {
    return false;
  }
};

export const isAdmin = () => {
  if(isAuthenticated() && isAuthenticated().user.role === 'admin') {
    return true;
  } else {
    return false;
  }
};
